import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ScrollDialog from 'shared/components/dialog/scrollDialog';

interface InputSelectListProps {
	label: string;
	name: string;
	handleClick: () => void;
	open: boolean;
	list: any;
	values: any;
	setFieldValue: (field: string, val: any) => void;
	className?: string;
	cySelectionTestRef?: string;
}

export const InputSelectList = (props: InputSelectListProps) => {
	const { t } = useTranslation();
	const { name, list, handleClick, open, values, setFieldValue, className, cySelectionTestRef } = props;

	return (
		<ScrollDialog open={open} onClose={handleClick} className={`inputSelect__list ${className}`}>
			<RadioGroup
				aria-label={name}
				name={name}
				value={values[name] || ''}
				className="country-list width--full"
				onChange={(e: any) => {
					const value = e.target.value;
					setFieldValue(name, value);
					handleClick();
				}}
			>
				{list.map((item: any, index: any) => {
					return (
						<FormControlLabel
							key={`selectItems-${name}-${index}`}
							value={item}
							control={<Radio value={item} />}
							label={
								<div key={index + 1} className="">
									{t(item)}
								</div>
							}
							labelPlacement="end"
							data-cy={cySelectionTestRef}
						/>
					);
				})}
			</RadioGroup>
		</ScrollDialog>
	);
};
